/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      window.PXUTheme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });

    const $form = $('#cart_form');
    // The `.update-cart` click handler that used to live here went with its button: the
    // cart switches apply instantly, so there is nothing left to "update". The
    // `.cart-attribute__field` handler below still runs (the Delivery radio uses it).

    $('#cart_form').on('change', '.cart-attribute__field', function (e) {
      /*$.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        beforeSend: function(){
          $('#cart_form button.update-cart').addClass('is-loading');
        },
        success: function success(data) {
          $('#cart_form button.update-cart').removeClass('is-loading');
          //window.PXUTheme.jsFixedMessageCart.hide();
          location.reload(true);
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
          console.log("Error, status = " + textStatus + ", " + "error thrown: " + errorThrown);
        }
      });*/
      // Assuming $form is a jQuery object, we get the native DOM element
      const formElement = $form[0]; 
      const updateBtn = document.querySelector('#cart_form button.update-cart');

      // 1. "beforeSend" equivalent: Run logic immediately before fetch
      if (updateBtn) {
        updateBtn.classList.add('is-loading');
      }

      fetch(formElement.action, {
        method: formElement.method,
        headers: {
          // jQuery sets this automatically for serialized forms; fetch needs it explicitly
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          // Many backends use this to detect if it is an AJAX request
          'X-Requested-With': 'XMLHttpRequest' 
        },
        // Replicates $form.serialize()
        body: new URLSearchParams(new FormData(formElement)).toString()
      })
      .then(response => {
        // fetch does not reject on HTTP errors (like 404 or 500), so we check manually
        if (!response.ok) {
          throw new Error('HTTP status ' + response.status);
        }
        // Assuming the response is JSON based on usage of data.items in your code
        return response.json();
      })
      .then(data => {
        // 2. "success" equivalent
        if (updateBtn) {
          updateBtn.classList.remove('is-loading');
        }

        location.reload(true);
      })
      .catch(error => {
        // 3. "error" equivalent
        console.log("Error, error thrown: " + error.message);
      });
      e.preventDefault();
    });
    
    $(document).ready(function() {
      $("input[name='attributes[Membership 會員狀態]']").click(function () {
        return false;
      });
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    /*$.ajax({
      type: 'POST',
      url: window.PXUTheme.routes.cart_url+'/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });*/
    fetch(window.PXUTheme.routes.cart_url + '/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: 'quantity=0&line=' + lineID
    })
    .then(response => {
      if (!response.ok) {
        // If the server returns a 400 or 500 error, parse the JSON to handle it
        return response.json().then(errData => {
          throw new Error(errData.description || 'Unknown error');
        });
      }
      return response.json();
    })
    .then(cart => {
      // Success Callback Logic
      $cartItem.addClass('animated zoomOut');
      $cartItem.remove();

      window.PXUTheme.jsCart.updateView(cart, lineID);

      if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
        window.PXUTheme.jsAjaxCart.updateView();
      }
    })
    .catch(error => {
      // Error Callback Logic
      // Note: 'error' here will be the Error object thrown above
      const responseDescription = error.message; 
      console.error('Error updating cart:', responseDescription);
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      // NEVER async:false here. This runs from the cart page's quantity box and its
      // line-delete path, both of which are user interactions, so a synchronous GET
      // blocks the main thread for the whole round trip and IS the interaction's
      // response time. Measured on the live cart against an idle control (4s idle =
      // 0ms worst task, 0 sync XHRs): one quantity click blocked the main thread for
      // 1,905ms, which is what put this page's field INP at 2,120ms while the rest of
      // the site sat at 96ms. Same defect class as the load-path one removed in
      // d4707fc. Both callers (z__jsCart's delete path, quantityBox.updateCart in
      // utilities.js) are terminal -- they call this last and read no return value --
      // so nothing needs it to finish first.
      $.ajax({
        cache: false,
        dataType: 'html',
        url: window.PXUTheme.routes.cart_url,
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          // The cart page's own delete / quantity edits come through HERE, not through
          // cartOp() -- this function replaces the item list and the totals one by one
          // and never touches .cart__form as a whole. So removing the last line that
          // carried a disclosure would leave the notice standing until a reload, while
          // the mini-cart copy (inside .ajax-cart__details-wrapper, replaced wholesale
          // by jsAjaxCart.updateView) clears correctly -- the two surfaces disagreeing
          // about what is in the cart. Removal is the only direction possible here:
          // nothing on this page ADDS a line.
          const disclosures = $(html).find('[data-cart-disclosures]');
          const $disclosures = $('[data-cart-disclosures]');

          if ($disclosures.length > 0) {
            if (disclosures.length > 0) {
              $disclosures.replaceWith(disclosures);
            } else {
              $disclosures.remove();
            }
          }

          // Same for the Google AI Price notice (snippets/cart-mf-notice.liquid): deleting the
          // Google item here must clear it. Scoped to .cart__form, because the mini-cart panel's
          // copies belong to jsAjaxCart.updateView.
          if ($(html).find('.cart__form [data-cart-mf-notice]').length < 1) {
            $('.cart__form [data-cart-mf-notice]').remove();
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;